import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const useRecipeTrashContextMenu = () => {
  const [selectedRecipe, setSelectedRecipe] = useState<any>(null);
  const [isRecipeDeleteConfirm, setIsRecipeDeleteConfirm] =
    useState<boolean>(false);
  const [restoreRecipeId, setRestoreRecipeId] = useState<string>('');
  const [isRecipeRestoreConfirm, setIsRecipeRestoreConfirm] =
    useState<boolean>(false);

  const { deleteItem, restoreItem } = useTrashRestoreDelete();

  const handleDeleteRecipe = (
    recipeId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteItem({
      module: 'recipes',
      moduleId: recipeId,
      onSuccess: () => {
        setSelectedRecipe(null);
        setIsRecipeDeleteConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestoreRecipe = (
    recipeId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreItem({
      module: 'recipes',
      moduleId: recipeId,
      onSuccess: () => {
        setRestoreRecipeId('');
        setIsRecipeRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsRecipeRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const recipeContextMenuItems = useCallback(
    (recipe: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestoreRecipeId(recipe?.id);
          setIsRecipeRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedRecipe(recipe?.id);
          setIsRecipeDeleteConfirm(true);
        }
      }
    ],
    []
  );

  return {
    recipeContextMenuItems,
    selectedRecipe,
    setSelectedRecipe,
    isRecipeDeleteConfirm,
    setIsRecipeDeleteConfirm,
    restoreRecipeId,
    setRestoreRecipeId,
    isRecipeRestoreConfirm,
    setIsRecipeRestoreConfirm,
    handleDeleteRecipe,
    handleRestoreRecipe
  };
};
